module.exports = __webpack_public_path__ + "static/media/S3N9-6.9d750fe0.svg";